export function customStylesSelectEventFn(theme) {
  return {
    control: (base, state) => ({
      ...base,
      alignItems: "flex-start",
      height: "37px",
      marginBottom: "0rem",
      flexFlow: "row nowrap",
      backgroundColor: state.isSelected && theme.customStylesSelectBackground,
      borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      border:
        state.isFocused && state.selectProps.isSearchable
          ? `1px solid ${theme.primaryColor}`
          : "1px solid rgba(43,61,80,0.1)",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        border:
          state.isFocused && state.selectProps.isSearchable
            ? `1px solid ${theme.primaryColor}`
            : "1px solid rgba(43, 61, 80, 0.1)",
      },
    }),
    option: styles => ({
      ...styles,
      color: theme.black75,
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "rgba(43, 61, 80, 0.1)",
      },
    }),
    indicatorsContainer: base => ({
      ...base,
      alignItems: "flex-start",
    }),
    menuList: (base, state) => ({
      ...base,
      padding: 0,
      border: `1px solid ${theme.primaryColor}`,
    }),
    multiValue: styles => ({
      ...styles,
      color: "#fff",
      backgroundColor: theme.interactionColor,
    }),
    menu: styles => ({
      ...styles,
      boxShadow: "none",
    }),
    multiValueLabel: base => ({
      ...base,
      color: "white",
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      "&:hover": {
        backgroundColor: theme.interactionColorDark,
        color: "#fff"
      }
    }),
  };
}
export function customStylesSelectFn(theme) {
  return {
    control: (base, state) => ({
      ...base,
      alignItems: "flex-start",
      height: "80px",
      flexFlow: "row nowrap",
      backgroundColor: state.isSelected && theme.customStylesSelectBackground,
      borderRadius: state.isFocused ? "3px 3px 0 0" : 3,
      border:
        state.isFocused && state.selectProps.isSearchable
          ? `1px solid ${theme.primaryColor}`
          : "1px solid rgba(43,61,80,0.1)",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        border:
          state.isFocused && state.selectProps.isSearchable
            ? `1px solid ${theme.primaryColor}`
            : "1px solid rgba(43, 61, 80, 0.1)",
      },
    }),
    option: styles => ({
      ...styles,
      color: theme.black75,
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "rgba(43, 61, 80, 0.1)",
      },
    }),
    indicatorsContainer: base => ({
      ...base,
      alignItems: "flex-start",
    }),
    menuList: (base, state) => ({
      ...base,
      padding: 0,
      border: `1px solid ${theme.primaryColor}`,
    }),
    multiValue: styles => ({
      ...styles,
      color: "#fff",
      backgroundColor: theme.interactionColor,
    }),
    menu: styles => ({
      ...styles,
      boxShadow: "none",
    }),
    multiValueLabel: base => ({
      ...base,
      color: "white",
    }),
    multiValueRemove: (base, state) => ({
      ...base,
      "&:hover": {
        backgroundColor: theme.interactionColorDark,
        color: "#fff"
      }
    }),
  };
}
